import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  AccountReceivableReversalReasonBean,
  AccountReceivableReversalReasonSearchCriteria,
  RestAccountReceivableReversalReasonListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";

class AccountReceivableReversalReasonListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editAccountReceivableReversalReason = (e, info) => {
    if (e.detail == 1) this.props.editAccountReceivableReversalReason(info);
  };
  deleteArReversalReason = (e, val, rowData) => {
    if (e.detail == 1) this.props.deleteArReversalReason(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  opentypeforms = (e) => {
    if (e.detail == 1) this.props.opentypeforms(e);
  };
  render() {
    let accountReceivableReversalReason_list =
      this.props.accountReceivableReversalReason_list;
    let accountReceivableReversalReasonData =
      this.props.accountReceivableReversalReasonData;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1.1">
              <FormLabel id="searchBarLabel">Reversal Reason</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                onChange={this.props.onChange}
                value={accountReceivableReversalReasonData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                ref={this.listFormCodeRef}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="2">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {accountReceivableReversalReason_list != null ? (
              <tbody>
                {accountReceivableReversalReason_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editAccountReceivableReversalReason(e, Info.code)
                        }
                      >
                        {Info.code}
                      </Button>
                    </td>
                    <td> {Info.description}</td>
                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* {Info.isApplied == false ? ( */}
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.deleteArReversalReason(e.altKey, Info.code)
                        }
                      >
                        <DeleteIcon />
                      </Button>
                    </td> */}
                    {/* ) : (
                    <Button variant="secondry">
                      <CancelIcon />
                    </Button>
                  )} */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {accountReceivableReversalReason_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class AccountReceivableReversalReasonEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
    this.state = {
      showHide: this.props.showHide,
      accountReceivableReversalReasonData:
        this.props.accountReceivableReversalReasonData,
    };
  }
  componentDidMount() {
    this.setInputFocus();
  }
  componentDidUpdate() {}
  onChange = (e) => {
    this.props.onChange(e);
  };
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  saveAccountReceivableReversalReason = (e) => {
    this.props.saveAccountReceivableReversalReason(
      this.state.accountReceivableReversalReasonData
    );
  };

  closeAccountReceivableReversalReasonEntryForm() {
    this.props.closeAccountReceivableReversalReasonEntryForm();
  }

  render() {
    let accountReceivableReversalReasonData =
      this.props.accountReceivableReversalReasonData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={accountReceivableReversalReasonData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              ref={this.codeRef}
              placeholder="Enter AccountReceivableReversalReasonCode"
              onChange={this.onChange}
              value={accountReceivableReversalReasonData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={accountReceivableReversalReasonData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={accountReceivableReversalReasonData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}

class AccountReceivableReversalReasonList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      accountReceivableReversalReason_list: [],
      response: {},
      pageTitle: "Account Receivable Reversal Reason",
      accountReceivableReversalReasonData:
        new AccountReceivableReversalReasonBean(),
      pageList: new PageListBean(),
      criteria: new AccountReceivableReversalReasonSearchCriteria(),
      companyCode: "",
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isAccountReceivableReversalReasonListFormOpen: true,
      isAccountReceivableReversalReasonEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let accountReceivableReversalReasonData =
      new AccountReceivableReversalReasonBean();
    accountReceivableReversalReasonData.companyCode = this.companyCode;
    this.loadPage(1);
    this.cleardata();
  }

  moduleCaption = "Account Receivable Reversal Reason";
  cleardata = () => {
    let accountReceivableReversalReasonData =
      new AccountReceivableReversalReasonBean();
    accountReceivableReversalReasonData.companyCode = this.companyCode;
    this.setState({
      accountReceivableReversalReasonData: accountReceivableReversalReasonData,
    });
  };
  opentypeforms = (e) => {
    if (e.detail == 1) {
      let accountReceivableReversalReasonData =
        this.state.accountReceivableReversalReasonData;
      this.editAccountReceivableReversalReason(
        accountReceivableReversalReasonData.code
      );
    }
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms(e);
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  saveAccountReceivableReversalReasonResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeAccountReceivableReversalReasonEntryForm();
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };

  saveAccountReceivableReversalReason = (
    accountReceivableReversalReasonData
  ) => {
    if (accountReceivableReversalReasonData.isFetched == true) {
      if (
        SecurityAccessManager.ArReversalReasonMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateAccountReceivableReversalReason(
          accountReceivableReversalReasonData,
          this.saveAccountReceivableReversalReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.ArReversalReasonMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createAccountReceivableReversalReason(
          accountReceivableReversalReasonData,
          this.saveAccountReceivableReversalReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  editAccountReceivableReversalReasonResponse = (response) => {
    if (response.data != null) {
      if (response.data.accountReceivableReversalReason != null) {
        let accountReceivableReversalReasonData =
          response.data.accountReceivableReversalReason;
        this.setState({
          accountReceivableReversalReasonData:
            accountReceivableReversalReasonData,
        });
        this.disable();
      }
    }
    this.openAccountReceivableReversalReasonEntryForm();
  };

  editAccountReceivableReversalReason = (
    accountReceivableReversalReasonCode
  ) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = accountReceivableReversalReasonCode;
    if (SecurityAccessManager.ArReversalReasonMaintenanceView_IsAccessible()) {
      MasterService.readAccountReceivableReversalReason(
        readrestInput,
        this.editAccountReceivableReversalReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let temp_accountReceivableReversalReasondata =
      this.state.accountReceivableReversalReasonData;
    temp_accountReceivableReversalReasondata[e.target.name] = e.target.value;
    this.setState({
      accountReceivableReversalReasonData:
        temp_accountReceivableReversalReasondata,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let accountReceivableReversalReasonData =
      this.state.accountReceivableReversalReasonData;
    accountReceivableReversalReasonData.companyCode = this.companyCode;
    accountReceivableReversalReasonData.code =
      this.state.accountReceivableReversalReasonData.code.toUpperCase();

    this.clearError();
    this.saveAccountReceivableReversalReason(
      accountReceivableReversalReasonData
    );
  };

  back = () => {
    this.cleardata();
    this.clearError();
    this.hideAlertCallBack(false);
    this.closeAccountReceivableReversalReasonEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openAccountReceivableReversalReasonEntryForm = () => {
    this.setState({
      isAccountReceivableReversalReasonListFormOpen: false,
      isAccountReceivableReversalReasonEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,

      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeAccountReceivableReversalReasonEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isAccountReceivableReversalReasonListFormOpen: true,
      isAccountReceivableReversalReasonEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,

      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
    this.loadPage(1);
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadAccountReceivableReversalReasonResponse = (response) => {
    if (
      response.data != null &&
      response.data.accountReceivableReversalReasonPageList != null
    ) {
      let accountReceivableReversalReasonList = new Array();
      if (
        !isEmptyArray(
          response.data.accountReceivableReversalReasonPageList
            .accountreceivableReversalReason
        )
      ) {
        accountReceivableReversalReasonList =
          response.data.accountReceivableReversalReasonPageList
            .accountreceivableReversalReason;
        accountReceivableReversalReasonList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage =
        response.data.accountReceivableReversalReasonPageList.currentPage;
      pageList.pageSize =
        response.data.accountReceivableReversalReasonPageList.pageSize;
      pageList.totalCount =
        response.data.accountReceivableReversalReasonPageList.totalCount;
      this.setState({
        accountReceivableReversalReason_list:
          accountReceivableReversalReasonList,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new AccountReceivableReversalReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadAccountReceivableReversalReasonPage(pageInput, criteria);
  };
  loadAccountReceivableReversalReasonPage = (pageList, searchCriteria) => {
    let criteria = new AccountReceivableReversalReasonSearchCriteria();
    criteria = searchCriteria;
    let requestInput = new RestAccountReceivableReversalReasonListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.ArReversalReasonMaintenanceView_IsAccessible()) {
      MasterService.getAccountReceivableReversalReasonPageList(
        requestInput,
        this.loadAccountReceivableReversalReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  deleteArReversalReason = (code, rowData) => {
    //
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.accountReceivableReversalReason_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ accountReceivableReversalReason_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isAccountReceivableReversalReasonListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isAccountReceivableReversalReasonListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isAccountReceivableReversalReasonListFormOpen && (
          <AccountReceivableReversalReasonListForm
            accountReceivableReversalReason_list={
              this.state.accountReceivableReversalReason_list
            }
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            opentypeforms={this.opentypeforms}
            accountReceivableReversalReasonData={
              this.state.accountReceivableReversalReasonData
            }
            editAccountReceivableReversalReason={
              this.editAccountReceivableReversalReason
            }
            deleteArReversalReason={this.deleteArReversalReason}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {!this.state.isAccountReceivableReversalReasonListFormOpen && (
          <AccountReceivableReversalReasonEntryForm
            accountReceivableReversalReasonData={
              this.state.accountReceivableReversalReasonData
            }
            closeAccountReceivableReversalReasonEntryForm={
              this.closeAccountReceivableReversalReasonEntryForm
            }
            saveAccountReceivableReversalReason={
              this.saveAccountReceivableReversalReason
            }
            editAccountReceivableReversalReason={
              this.editAccountReceivableReversalReaso
            }
            onChange={this.onChange}
            isDisableFields={this.state.isDisableFields}
          />
        )}
      </div>
    );
  }
}

function AccountReceivableReversalReasonAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <AccountReceivableReversalReasonList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default AccountReceivableReversalReasonAttributeModule;
